<template>
  <div>
    <vue-element-loading :active="isLoading" :is-full-screen="true" />
    <v-card>
      <v-card-title>
        <v-icon color="primary"> mdi-credit-card-outline </v-icon>
        <span class="pl-2">{{ $t('pages.edit_payment') }}</span>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="$router.go(-1)" class="mx-1">
          {{ $t('pages.back') }}
          <v-icon right dark> mdi-keyboard-return </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          class="multi-col-validation mt-6"
          lazy-validation
        >
          <v-row>
            <v-col md="6" cols="12">
              <v-autocomplete
                v-model="payment.student_id"
                :items="students"
                item-text="name"
                item-value="id"
                clearable
                dense
                outlined
                :label="$t('forms.students')"
                :rules="studentRules"
              ></v-autocomplete>
            </v-col>
            <v-col md="6" cols="12">
              <v-text-field
                v-model="payment.amount"
                :label="$t('forms.amount')"
                dense
                outlined
                required
                prefix="€"
                type="number"
                :rules="amountRules"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <v-menu
                ref="monthsMenu"
                v-model="monthsMenu"
                :close-on-content-click="false"
                :return-value.sync="payment.months"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-combobox
                    v-model="payment.months"
                    multiple
                    dense
                    outlined
                    chips
                    small-chips
                    :label="$t('forms.months')"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="monthsRules"
                  ></v-combobox>
                </template>
                <v-date-picker
                  v-model="payment.months"
                  type="month"
                  multiple
                  no-title
                  scrollable
                  :min="minDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="monthsMenu = false">
                    {{ $t('actions.cancel') }}
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.monthsMenu.save(payment.months)"
                  >
                    {{ $t('actions.ok') }}
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                @click="editPayment"
                :loading="isEditing"
              >
                {{ $t('actions.save_changes') }}
              </v-btn>
              <v-btn color="secondary" outlined class="mt-4" @click="cancel">
                {{ $t('actions.cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading';
import CreateButton from '@/components/CreateButton.vue';

export default {
  components: { VueElementLoading, CreateButton },
  data() {
    return {
      isLoading: false,
      isEditing: false,
      payment_id: null,
      payment: {
        student_id: null,
        amount: null,
        months: [],
      },
      valid: true,
      monthsMenu: null,
      students: [],
      studentRules: [(v) => !!v || this.$t('messages.is_required')],
      amountRules: [(v) => !!v || this.$t('messages.is_required')],
      monthsRules: [(v) => v.length > 0 || this.$t('messages.is_required')],
    };
  },
  mounted() {
    if (this.$route.params.payment_id != null) {
      this.payment_id = this.$route.params.payment_id;
    }
    this.getAllStudents();
    this.loadPayment();
  },
  computed: {
    minDate: function () {
      const now = new Date();
      return now.toISOString().slice(0, 7);
    },
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    getAllStudents() {
      axios
        .get('/users/all-students-list')
        .then((response) => {
          this.students = response?.data;
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error fetching students',
            type: 'error',
          });
        });
    },
    loadPayment() {
      this.isLoading = true;
      axios
        .get(`/school/payments/${this.payment_id}`)
        .then((response) => {
          this.payment = response?.data;
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error fetching payment',
            type: 'error',
          });
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    editPayment() {
      if (!this.validate()) return;
      this.isEditing = true;
      const data = { ...this.payment };
      axios
        .put(`/school/payments/${this.payment_id}`, data)
        .then(() => {
          this.$notify({
            title: 'Success',
            text: 'Payment updated!',
            type: 'success',
          });
          this.$router.go(-1);
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error updating payment',
            type: 'error',
          });
        })
        .then(() => {
          this.isEditing = false;
        });
    },
    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped></style>
